import React from "react";
import "./Aboutheader.css";
import { Link } from "react-router-dom";

/**
 * New props:
 * - accent: "emerald" | "gold" | "ink" (sets local accent tokens)
 * - overlay: number 0..1 (tunes left-to-right overlay strength)
 * - badges: string[] (optional chips under copy)
 * - stats: [{label: string, value: string}] (optional mini-metrics row)
 */
export default function Aboutheader({
  bgSrc = "./abtheaderrr.jpg",
  eyebrow = "About Emerald Appraisal Services",

  /* ---------- UPDATED PER CLIENT REQUEST ---------- */
  title = "Certified Residential Appraiser serving the Greater Puget Sound Region",
  body = "Emerald Appraisal Services is a certified residential appraisal firm based in Pierce County, Washington. We serve the Greater Puget Sound region—including Pierce, King, Thurston, Lewis, Mason, Kitsap, Grays Harbor and Snohomish counties—with professional residential valuation services.",
  body2 = "We work with a wide range of clients from lenders and attorneys to homeowners and investors, providing appraisals for purchases, refinances, estate settlements, divorce and separation, and pre-listing appraisals.",
  body3 = "Property types include single-family homes, condominiums, townhomes, 2–4 unit small multi-family, manufactured homes, and vacant land. We also provide professional sketching. We stay current with industry and lending guidelines, including USPAP standards, to deliver timely, accurate, and well-supported reports.",
  /* ------------------------------------------------ */

  ctaText = "Contact Us Today",
  onCtaClick = () => {},
  accent = "emerald",
  overlay = 0.9,
  badges = ["Certified Residential • USPAP", "FHA Approved", "Puget Sound Counties"],
}) {
  // clamp overlay for safety
  const ov = Math.min(1, Math.max(0, overlay));

  return (
    <section
      className={`Aboutheader Aboutheader--${accent}`}
      aria-labelledby="Aboutheader-title"
      style={{ "--ov": ov }}
    >
      {/* Background layers */}
      <div className="Aboutheader__bg" aria-hidden="true">
        <img
          src={bgSrc}
          alt=""
          className="Aboutheader__bg-img"
          width={1920}
          height={900}
          loading="eager"
          decoding="async"
        />
        <div className="Aboutheader__bg-overlay" />
        <div className="Aboutheader__bg-pattern" />
      </div>

      {/* Content */}
      <div className="Aboutheader__container">
        <div className="Aboutheader__content">
          <p className="Aboutheader__eyebrow">{eyebrow}</p>
          <h2 id="Aboutheader-title" className="Aboutheader__title">
            {title}
          </h2>

          <p className="Aboutheader__text">{body}</p>
          <p className="Aboutheader__text">{body2}</p>
          <p className="Aboutheader__text">{body3}</p>

          {badges?.length > 0 && (
            <div className="Aboutheader__badges" role="list">
              {badges.map((b, i) => (
                <span key={i} role="listitem" className="Aboutheader__badge">
                  {b}
                </span>
              ))}
            </div>
          )}

          <Link
            to="/contact"
            className="Aboutheader__cta"
            aria-label={ctaText}
          >
            <span>{ctaText}</span>
            <span className="material-icons Aboutheader__cta-icon">
              arrow_forward
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
